import {
  getObjectStorageAction,
  getObjectStorageFormData,
  getUploadParams,
} from '@/components/Upload/service';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { useState } from 'react';

export default ({
  onChange,
  value,
  buttonText,
  onUploadingChange,
  bucket = 'savvyuni-intl-erp',
  folderId,
  ...rest
}) => {
  const [ossData, setOssData] = useState();
  const [fileList, setFileList] = useState(Array.isArray(value) ? value : !!value ? [value] : []);
  const uploadAction = getObjectStorageAction(bucket, ossData);

  const getOSSAuth = async (file) => {
    if (!ossData || new Date().getTime() > ossData.expire) {
      const res = await getUploadParams({ bucket, folderId });
      setOssData(res);
      return getObjectStorageFormData(res, `${res.dir}/${file.name}`, bucket);
    } else {
      return getObjectStorageFormData(ossData, `${ossData.dir}/${file.name}`, bucket);
    }
  };
  const onUploadChange = ({ file, fileList }) => {
    setFileList(fileList);

    const isUploading = fileList.some((f) => f.status === 'uploading');
    if (onUploadingChange) onUploadingChange(isUploading);

    if (onChange && typeof onChange === 'function') {
      if (file.status === 'done') {
        if (rest.maxCount === 1) {
          onChange({
            ...file,
            bucket,
            key: `${ossData.dir}/${file.name}`,
          });
        } else {
          onChange(
            fileList.map((f) => {
              return {
                ...f,
                bucket,
                key: `${ossData.dir}/${f.name}`,
              };
            }),
          );
        }
      } else if (file.status === 'removed') {
        if (rest.maxCount === 1) {
          onChange(null);
        } else {
          onChange(fileList);
        }
      }
    }
  };
  return (
    <Upload
      action={uploadAction}
      data={getOSSAuth}
      fileList={fileList}
      onChange={onUploadChange}
      {...rest}
    >
      <Button icon={<UploadOutlined />}>{buttonText || '点击上传'}</Button>
    </Upload>
  );
};
